import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  MotifButton,
  MotifFormField,
  MotifLabel,
  MotifSelect,
  MotifOption,
} from "@ey-xd/motif-react";
import Input from "../../../common/components/Input/Input";
import "./ReportType.scss";
import ReportTypeImg from "../../../assets/media/images/report_type.png";
import Modal from "../../../common/components/Modal/Modal";
import { MotifInput } from "@ey-xd/motif-react";
import { MotifDatePicker } from "@ey-xd/motif-react";
import {
  createReport,
  getVulnerabilityCategories,
  upadateReport,
} from "../../../redux/actions/SideBar/sideBar";
import { getApplicationProfiles } from "../../../redux/actions/ApplicationProfile/applicationProfile";
import { MotifProgressLoader } from "@ey-xd/motif-react";
import MotifErrorMessage from "@ey-xd/motif-react/components/forms/error-message";
import {
  MAX_INPUT_LENGTH,
  isMaliciousInput,
  maliciousInputErrorMsg,
} from "components/Clients/constants";
import { avoidXSSattackOnReportName, avoidXSSattackOnReportLibrary , isValidHttpOrHttpsUrl} from "utils/security";
import { MotifIcon } from "@ey-xd/motif-react";
import { actionIcHelpOutline24px } from "@ey-xd/motif-react/assets/icons";

const ReportType = ({
  reportType,
  setReportType,
  clientName,
  setClientName,
  reportName,
  setReportName,
  setShowAddFinding,
  setFormData,
  reportInformation,
  reportID,
  findings,
  setShowFindingForm,
  handlePostResponse,
}: any) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [client, setClient] = useState(reportInformation?.clientName || "");
  const [report, setReport] = useState(reportInformation?.reportName || "");
  const [applicationName, setApplicationName] = useState(
    reportInformation?.applicationName || ""
  );
  const [applicationProfileId, setApplicationProfileId] = useState(
    reportInformation?.applicationProfileId || ""
  );
  const [applicationProfileName, setApplicationProfileName] = useState(
    reportInformation?.applicationProfileName || ""
  );
  const [applicationInterface, setApplicationInterface] = useState(
    reportInformation?.applicationInterface || ""
  );
  const [workOrderNumber, setWorkOrderNumber] = useState(
    String(reportInformation?.workOrderNumber ?? "")
  );
  const [targetURL, setTargetURL] = useState(
    reportInformation?.targetURL || ""
  );
  const [dateRange, onchange] = useState(
    reportInformation?.dateRange
      ? [
          new Date(reportInformation.dateRange[0]),
          new Date(reportInformation.dateRange[1]),
        ]
      : [new Date(), new Date()]
  );
  const isReportCreated = useSelector(
    (state: any) => state.sideBar.isReportCreated
  );
  const [showSpinner, setShowSpinner] = useState(false);
  const error = useSelector((state: any) => state.sideBar.error);
  const errormessage = useSelector((state: any) => state.sideBar.errorMessage);
  const isEdit = useSelector((state: any) => state.sideBar.isEdit);
  const [targetUrlError, setTargetUrlError] = useState<string | null>(null);
  const [showProfileChangeModal, setShowProfileChangeModal] = useState(false);
  const [pendingProfileId, setPendingProfileId] = useState<string | null>(null);
  const [workOrderSearch, setWorkOrderSearch] = useState(String(reportInformation?.workOrderNumber ?? ""));
  const [workOrderDropdownOpen, setWorkOrderDropdownOpen] = useState(false);
  const [errorShown, setErrorShown] = useState(false);
  const currentTenant = useSelector(
    (state: any) => state?.user?.currentTenant
  );
  const currentTenantId = currentTenant?.TenantId || "";
  const isAiaTenant =
    (currentTenant?.TenantName || "").toLowerCase() === "aia";
  const applicationProfileData = useSelector(
    (state: any) => state?.applicationProfile?.data
  );
  const applicationProfiles = Array.isArray(applicationProfileData?.data)
    ? applicationProfileData.data
    : Array.isArray(applicationProfileData)
    ? applicationProfileData
    : [];

  // const isValidHttpsUrl = (url: string) => /^https:\/\/.+/.test(url);
  const normalizeProfileId = (value: any) =>
    String(value?.value ?? value ?? "");

  const handleProfileChange = (val: any) => {
    const normalizedId = normalizeProfileId(val);
    const selected = (applicationProfiles || []).find(
      (profile: any) =>
        String(profile?.ApplicationId ?? "") === normalizedId
    );
    setApplicationProfileId(normalizedId);
    setApplicationProfileName(selected?.ApplicationName || "");
    setApplicationName(selected?.ApplicationName || "");
    const selectedWorkOrder = String(selected?.WorkOrder ?? "");
    setWorkOrderNumber(selectedWorkOrder);
    setWorkOrderSearch(selectedWorkOrder);
    // Auto-populate Report Name with BU + Application Name
    const businessUnit = selected?.BusinessUnitName || "";
    const appName = selected?.ApplicationName || "";
    const autoReportName = businessUnit && appName ? `${businessUnit} ${appName}` : "";
    setReport(autoReportName);
  };

  const handleSubmit = () => {
    setShowSpinner(true);
    setReportName(report);
    if (!isAiaTenant) {
      setClientName(client);
    }
    setFormData({
      reportName: report,
      ...(!isAiaTenant
        ? {
            clientName: client,
            targetURL,
          }
        : {}),
      applicationName,
      ...(isAiaTenant
        ? {
            applicationProfileId,
            applicationProfileName,
            applicationInterface,
            workOrderNumber,
          }
        : {}),
      dateRange,
    });

    if (isEdit) {
      const data = {
        report_id: reportID,
        data: {
          ...(isAiaTenant
            ? {
                application_id: applicationProfileId,
                application_network: applicationInterface,
                report_name: report,
                work_order: workOrderNumber,
              }
            : {
                ApplicationName: applicationName,
                ReportName: report,
                ClientName: client,
                targetURL,
              }),
          StartDate: dateRange[0].toLocaleDateString("en-US"),
          EndDate: dateRange[1].toLocaleDateString("en-US"),
        },
      };
      dispatch(upadateReport(data));
      dispatch(getVulnerabilityCategories());
    } else {
      dispatch(
        createReport({
          ...(isAiaTenant
            ? {
                application_id: applicationProfileId,
                application_name: applicationName,
                application_network: applicationInterface,
                report_name: report,
                work_order: workOrderNumber,
              }
            : {
                report_name: report,
                client_name: client,
                target_url: targetURL,
                application_name: applicationName,
              }),
          date: `${dateRange[0].toLocaleDateString(
            "en-US"
          )} - ${dateRange[1].toLocaleDateString("en-US")}`
          // date: `${dateRange[0].toLocaleString(
          //   "en-GB", { day: '2-digit', month: '2-digit', year: 'numeric' }
          // )} - ${dateRange[1].toLocaleString("en-GB", { day: '2-digit', month: '2-digit', year: 'numeric' })}`
        })
      );
      dispatch(getVulnerabilityCategories());
    }
  };

  const checkIfMaliicousText = () => {
    return (
      (!isAiaTenant && isMaliciousInput(report)) ||
      (isAiaTenant && isMaliciousInput(report)) ||
      (!isAiaTenant && isMaliciousInput(client)) ||
      isMaliciousInput(applicationName) ||
      (!isAiaTenant && isMaliciousInput(targetURL))
    );
  };

  useEffect(() => {
    if (isReportCreated && findings.length === 0) {
      setShowAddFinding(true);
    }

    if (isReportCreated && findings.length > 0) {
      setShowFindingForm(true);
    }
  }, [isReportCreated, findings]);

  useEffect(() => {
    if (error && !errorShown) {
      setShowSpinner(false);
      if (handlePostResponse && errormessage) {
        const errorMsg = typeof errormessage === 'string' 
          ? errormessage 
          : errormessage?.error_message || errormessage?.message || "Failed to create report. Please try again.";
        handlePostResponse("Error", errorMsg, "error");
        setErrorShown(true);
      }
    } else if (!error && errorShown) {
      // Reset error shown flag when error is cleared
      setErrorShown(false);
    }
  }, [error, errormessage, handlePostResponse, errorShown]);

  useEffect(() => {
    if (isAiaTenant) {
      dispatch(getApplicationProfiles());
    }
  }, [dispatch, isAiaTenant]);

  useEffect(() => {
    if (!isAiaTenant) {
      setApplicationProfileId("");
      setApplicationProfileName("");
      setApplicationInterface("");
      setWorkOrderNumber("");
      setWorkOrderSearch("");
    }
  }, [isAiaTenant]);

  useEffect(() => {
      setReport("");
      setReportName("");
    setClient("");
    setApplicationName("");
    setApplicationProfileId("");
    setApplicationProfileName("");
    setApplicationInterface("");
    setWorkOrderNumber("");
    setWorkOrderSearch("");
    setTargetURL("");
    setTargetUrlError(null);
  }, [currentTenantId, setReportName]);

  return (
    <div className="clientDetails">
      <MotifProgressLoader show={showSpinner} />
      <Modal
        isVisible={showProfileChangeModal}
        setVisible={setShowProfileChangeModal}
        confirmButtonText="OK"
        headerContent={
          <div className="modal__header">
            <h2>Confirm Profile Change</h2>
          </div>
        }
        bodyContent={
          <div className="modal__body">
            <p>Changing the application profile will change the associated values</p>
          </div>
        }
        onConfirmClick={() => {
          if (pendingProfileId) {
            handleProfileChange(pendingProfileId);
            setPendingProfileId(null);
          }
          setShowProfileChangeModal(false);
        }}
        onCancelClick={() => {
          setPendingProfileId(null);
          setWorkOrderSearch(String(workOrderNumber ?? ""));
        }}
      />
      <img src={ReportTypeImg} />
      <div className="clientDetails__title">
        Please provide the inputs to start building the Penetration Testing
        report
      </div>
      {/* <div className="clientDetails__desc">Please select the client you will be generating a report for to proceed.</div> */}
      <div className="clientDetails__layout">
      <div className="clientDetails__form">
        {isAiaTenant && (
          <>
            <span>Work Order Number (required)</span>
            <div style={{ position: "relative" }} className="clientDetails__formField">
              <MotifFormField style={{ marginBottom: 0 }}>
                {!workOrderSearch && <MotifLabel>Search Work Order Number</MotifLabel>}
                <MotifInput
                  value={workOrderSearch}
                  onChange={(e: any) => {
                    setWorkOrderSearch(String(e?.target?.value ?? ""));
                    setWorkOrderDropdownOpen(true);
                    if (!e.target.value) {
                      setWorkOrderNumber("");
                      setApplicationProfileId("");
                      setApplicationProfileName("");
                      setApplicationName("");
                      setReport("");
                    }
                  }}
                  onFocus={() => setWorkOrderDropdownOpen(true)}
                  onBlur={() => setTimeout(() => setWorkOrderDropdownOpen(false), 200)}
                />
              </MotifFormField>
              {workOrderDropdownOpen && (
                <div className="workOrder__searchDropdown">
                  {(applicationProfiles || [])
                    .filter(
                      (p: any) =>
                        !!p?.WorkOrder &&
                        String(p?.WorkOrder || "").toLowerCase().includes(String(workOrderSearch ?? "").toLowerCase())
                    )
                    .map((profile: any) => (
                      <div
                        key={profile?.ApplicationId}
                        className="workOrder__searchDropdown__option"
                        onMouseDown={(e) => {
                          e.preventDefault();
                          const nextId = String(profile?.ApplicationId);
                          const currentId = normalizeProfileId(applicationProfileId);
                          if (currentId && currentId !== nextId) {
                            setPendingProfileId(nextId);
                            setShowProfileChangeModal(true);
                          } else {
                            handleProfileChange(nextId);
                          }
                          setWorkOrderDropdownOpen(false);
                        }}
                      >
                        {profile?.WorkOrder}
                      </div>
                    ))}
                </div>
              )}
            </div>
            <span>Application Interface (required)</span>
            <MotifFormField className="clientDetails__formField">
              <MotifLabel>Select Application Interface</MotifLabel>
              <MotifSelect
                onChange={(val: any) => setApplicationInterface(val)}
                value={applicationInterface}
                visibleOptions={2}
              >
                <MotifOption value="External">External</MotifOption>
                <MotifOption value="Internal">Internal</MotifOption>
                <MotifOption value="External & Internal">External & Internal</MotifOption>
              </MotifSelect>
            </MotifFormField>
          </>
        )}
        <span>Report Name (required)</span>
        <MotifFormField className="clientDetails__formField">
          <MotifLabel>Report Name (required)</MotifLabel>
          <MotifInput
            value={report}
            onChange={(e: any) => {
              if (!isAiaTenant) {
                e = avoidXSSattackOnReportName(e);
                setReport(e.target.value);
              }
            }}
            maxLength={MAX_INPUT_LENGTH}
          ></MotifInput>
          {isMaliciousInput(report) && (
            <MotifErrorMessage role="alert">
              {maliciousInputErrorMsg}
            </MotifErrorMessage>
          )}

          {error && errormessage.report_name_error_message && (
            <MotifErrorMessage role="alert">
              {errormessage.report_name_error_message}
            </MotifErrorMessage>
          )}
          {error && errormessage?.error?.message && (
            <MotifErrorMessage role="alert">
              {errormessage.error.message}
            </MotifErrorMessage>
          )}
        </MotifFormField>
        {!isAiaTenant && (
          <>
        <span>Client Name (required)</span>
        <MotifFormField className="clientDetails__formField">
          <MotifLabel>Client Name</MotifLabel>
          <MotifInput
            value={client}
            onChange={(e: any) => {
              e = avoidXSSattackOnReportLibrary(e);
              setClient(e.target.value);
            }}
            maxLength={MAX_INPUT_LENGTH}
          ></MotifInput>
          {isMaliciousInput(client) && (
            <MotifErrorMessage role="alert">
              {maliciousInputErrorMsg}
            </MotifErrorMessage>
          )}
          {error && errormessage.client_name_error_message && (
            <MotifErrorMessage role="alert">
              {errormessage.client_name_error_message}
            </MotifErrorMessage>
          )}
        </MotifFormField>
        <span>Application Name (required)</span>
        <MotifFormField className="clientDetails__formField">
          <MotifLabel>Application Name</MotifLabel>
          <MotifInput
            value={applicationName}
            onChange={(e: any) => {
              e = avoidXSSattackOnReportName(e);
              setApplicationName(e.target.value);
            }}
            maxLength={MAX_INPUT_LENGTH}
          ></MotifInput>
          {isMaliciousInput(applicationName) && (
            <MotifErrorMessage role="alert">
              {maliciousInputErrorMsg}
            </MotifErrorMessage>
          )}
          {error && errormessage.application_name_error_message && (
            <MotifErrorMessage role="alert">
              {errormessage.application_name_error_message}
            </MotifErrorMessage>
          )}
        </MotifFormField>
        {/* Target URL */}
        <span>Target URL (required)</span>
        <MotifFormField className="clientDetails__formField">
          <MotifLabel>Target URL</MotifLabel>
          <MotifInput
            value={targetURL}
            onChange={(e: any) => {
              // e = avoidXSSattackOnReportLibrary(e);
              setTargetURL(e.target.value);
              e = isValidHttpOrHttpsUrl(e.target.value);
              if (!e) {
                setTargetUrlError("Target URL must either start with http:// or https://");  
              } else {
                setTargetUrlError(null);
              }
            }}
            maxLength={MAX_INPUT_LENGTH}
          ></MotifInput>
          {isMaliciousInput(targetURL) && (
            <MotifErrorMessage role="alert">
              {maliciousInputErrorMsg}
            </MotifErrorMessage>
          )}
          {error && errormessage.target_url_error_message && (
            <MotifErrorMessage role="alert">
              {errormessage.target_url_error_message}
            </MotifErrorMessage>
          )}
          {targetUrlError && (
            <MotifErrorMessage role="alert">
              {targetUrlError}
            </MotifErrorMessage>
          )}
        </MotifFormField>
        </>
        )}

        {/*  */}
        <span>Test Start Date - Test End date (required)</span>
        <MotifFormField className="clientDetails__formField">
          <MotifLabel>DD/MM/YYYY - DD/MM/YYYY</MotifLabel>
          <MotifDatePicker
            dayPlaceholder="DD"
            monthPlaceholder="MM"
            yearPlaceholder="YYYY"
            format="dd-MM-yyyy"
            onChange={onchange}
            value={dateRange}
            range={true}
          />
        </MotifFormField>

        <div style={{ display: "flex", justifyContent: "center" }}>
          <MotifButton
            size="medium"
            variant="primary"
            onClick={handleSubmit}
            disabled={
              (!isAiaTenant && !report) ||
              (isAiaTenant && !report) ||
              (!isAiaTenant && !client) ||
              (isAiaTenant && !applicationProfileId) ||
              (isAiaTenant && !workOrderNumber) ||
              (isAiaTenant && !applicationInterface) ||
              (!isAiaTenant && !applicationName) ||
              (!isAiaTenant && !targetURL) ||
              !dateRange ||
              (!isAiaTenant && targetUrlError !== null) ||
              checkIfMaliicousText()
            }
          >
            {isEdit ? "Update" : "Start"} Building Report
          </MotifButton>
        </div>
      </div>
        {isAiaTenant && <div className="clientDetails__button">
          <MotifButton
            size="medium"
            variant="text"
            type="button"
            className="right-element"
            onClick={() => navigate("/applicationProfile", { state: { showForm: true } })}
          >
            <MotifIcon
              src={actionIcHelpOutline24px}
            />Create Application
          </MotifButton>
        </div>}
      </div>
    </div>
  );
};

export default ReportType;
